import React from "react";

import { translation } from "@/i18n";
import { nsDialog } from "@/i18n/locales/dialog";
import { useDialogStyles } from "@/styles";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";
import { ErrorCircle24Filled } from "@fluentui/react-icons";
import styles from "../index.module.css";

const useTranslation = translation.use(nsDialog);

export const DialogErrorOffline: React.FC = () => {
  const { t } = useTranslation();
  const dialogClasses = useDialogStyles();
  return (
    <Dialog>
      <DialogSurface className={dialogClasses.dialog}>
        <DialogBody>
          <DialogTitle>
            <div className={styles.titleWithIcon}>
              <ErrorCircle24Filled className={styles.errorIcon} />
              {t.dialog.offline.title()}
            </div>
          </DialogTitle>
          <DialogContent>
            <div className={styles.errorResponse}>
              {t.dialog.offline.message()}
            </div>
          </DialogContent>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
